import React, { useEffect, useState, useRef } from "react";
import styles from "./menuBar.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Avatar from "@mui/material/Avatar";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import { useNavigate } from "react-router";
import Login, { LoginRightBanner, loginScreen } from "../../../login/login";
import ChangePassword from "../../../login/changePassword";
import { Button, Dialog, DialogTitle } from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import {
  apiRequest,
  authService,
  catchErrorMessageHandler,
  getUserName,
  getUserSelectedRole,
  getaccessToken,
} from "../../../../infrastructure/backendService";
import {
  CommonButton,
  CommonLogoutButton,
  CustomCloseIcon,
} from "../../../common/StyledComponents/StyledFields";
import { isNil } from "lodash";
import CommonDonationPopup from "../../../home/CommonDonationPopup";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { roleListProps } from "../../../../infrastructure/GlobalContextProvider";
import { CustomTooltip } from "../../../common/muhurtham/muhurtham";
import ToastError from "../../../common/toast/toastError";
import toast from "react-hot-toast";
import apiPath from "../../../../config/apiPaths.json";
import { useSearchParams } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import styled from "@emotion/styled";
import ErrorPopup from "../../../common/ErrorPopup";
import constants from "../../../../config/constants.json";
import { RoutingURLs, SubRoutingURLs } from "../../../common/RoutingURLs";
import loginBgBanner from "../../../../assets/loginBgBanner.png";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

const CustomMobileMenuIcon = styled(MenuIcon)`
  color: #fff;
  font-size: 40px;
`;

const MenuBar = (): JSX.Element => {
  const navigation = useNavigate();
  const role = getUserSelectedRole() || "";
  const [activeTab, setActiveTab] = useState<string | null>(null);
  const subRoles = authService.getUserRoles();
  const [selectedRole, setSelectedRole] = useState<string | null>(null);
  const [showChangePassword, setShowChangePassword] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [activeSubTab, setActiveSubTab] = useState<string | null>(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const [showSubRoles, setShowSubRoles] = useState(false);
  const userName = sessionStorage.getItem("username");
  const [selectedItem, setSelectedItem] = useState(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const userDetailsRef = useRef<HTMLDivElement>(null);
  const name = sessionStorage.getItem("name");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const currentYear = new Date().getFullYear();
  const rolesForLink: string[] = [
    "Devotee",
    "Steering Committee Member",
    "Administrative Assistant",
    "Front Desk",
    "Office Staff",
    "Steering Committee Member - Active",
    "Facilities Manager",
    "Corporate Secretary - BOD",
    "Member Board of Directors",
    "Super Administrator",
    "Chairman",
    "President",
    "Treasurer",
    "Manager",
    "Chairman - Construction Committee",
    "Chairman - Information System",
    "Chairman - Maintenance Committee",
    "Chairman - Religious Committee",
    "Chairman - Inventory Control",
    "Chairman - Public Relations",
    "Chairman - Human Services",
    "Chairman - Fund Raising",
    "Chairman - Youth and Cultural",
    "Chairman - Assembly Hall",
    "Chairman - Publicity Committee",
    "Chairman - Human Resources",
    "Chairman - Cultural",
    "Chairman - Treasury",
    "Chairman - Adminstration",
    "Chairman - Food Committee",
    "Chairman - Facilities",
    "Chairman-MKA2010",
    "Chair-General Inventory & Procurement",
    "Priest"
  ];
  const [searchParam] = useSearchParams();
  const DevoteeId = searchParam.get("DevoteeId");

  const showDonation = searchParam.get("donationID")

  useEffect(() => {
    if (!isNil(showDonation)) {
      handleClickDonation();
    }
  }, [showDonation])

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
    // Find the specific heading element by its ID or class name
    const devoteebooking = document.getElementById("menuBar");
    if (devoteebooking) {
      devoteebooking.scrollIntoView({ behavior: "smooth" }); // Scroll to the top
    }
  }, []);

  const getRole = (): string | null => {
    if (isNil(role) || role === undefined || !isNil(selectedRole)) {
      return selectedRole;
    } else {
      return getUserSelectedRole();
    }
  };

  useEffect(() => {
    if (authService.isAuthenticated()) {
      getUserDefaultRole();
    }
  }, [])

  const getUserDefaultRole = () => {
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.userRolesInfo}`,
      includeToken: true,
      params: {
        username: userName,
      },
    })
      .then((res) => {
        // Combine active and inActive lists into a single string with comma separation
        const rolesJsonString = JSON.stringify(res.data.roles);
        sessionStorage.setItem("user-roles", rolesJsonString);
        sessionStorage.setItem("name", res.data.fullName);
        sessionStorage.setItem("firstAndLastName", res.data.firstAndLastName);
      })
      .catch((err) => {
        console.log(err);
        sessionStorage.clear();
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  };

  // useEffect(() => {
  //   // if(isNil(DevoteeId)) {
  //   if (
  //     getRole()?.toLowerCase() === "manager" ||
  //     getRole() === "Front Desk" ||
  //     getRole() === "Office Staff" ||
  //     getRole() === "Administrative Assistant" ||
  //     getRole() === "Facilities Manager"
  //   ) {
  //     navigation(
  //       "/managerDashboard/devoteeservice/Devotee Pooja & Hall Requests"
  //     );
  //   } else {
  //     navigation("/dashboard");
  //   }
  //   // }
  // }, [selectedRole]);

  const handleDonateClose = (): void => {
    setIsOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (
        userDetailsRef.current &&
        !userDetailsRef.current.contains(event.target)
      ) {
        setMenuVisible(false);
        setShowSubRoles(false);
      }
    }
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickHome = () => {
    navigation("/");
  };

  const handleClickDashboard = () => {
    // if(isNil(priestId)) {
    if (
      constants.showDashBoardForRoles.includes(role)
    ) {
      if (constants.LANDINGPAGE_AUTHORIZE.includes(role)) {
        navigation(
          `/managerDashboard/expense-voucher/${SubRoutingURLs.AUTHORIZE}`
        );
      } else if (constants.LANDINGPAGE_MYSCHEDULES.includes(role)) {
        navigation(`/managerDashboard/schedules/${SubRoutingURLs.MY_SCHEDULE}`);
      } else {
        navigation(
          `/managerDashboard/devoteeservice/${SubRoutingURLs.DEVOTEE_POOJA_AND_HALL_REQUESTS}`
        );
      }
    } else {
      navigation(RoutingURLs.dashboard);
    }
    // }
  };

  const handleClickCalender = () => {
    navigation("/Calendar");
  };

  const handleClickDonation = () => {
    if (authService.isAuthenticated()) {
      // User is logged in, redirect to the logged-in donations page
      navigation(`/donations?donationID=${showDonation}`);
      setOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  const handleTempleHistory = () => {
    window.open("https://hccccars.org/", "_blank");
  };

  const handleSubTabMouseEnter = (subTab: string) => {
    setActiveSubTab(subTab);
  };

  const handleSubTabMouseLeave = () => {
    setActiveSubTab(null);
  };

  const menuData = [
    {
      page: "Home",
      onclickFunction: () => {
        handleClickHome();
        window.scrollTo(0, 0);
      },
      isShow: true,
    },
    {
      page: "My Dashboard",
      onclickFunction: () => {
        handleClickDashboard();
        window.scrollTo(0, 0);
      },
      isShow: authService.isAuthenticated(),
    },
    {
      page: "Information",
      icon: <ExpandMoreIcon style={{position:"relative", top:"3px"}}/>,
      subTabs: [
        {
          subTab: "Overview",
        },
        {
          subTab: "Pooja Items",
          supersubItems: [
            "Individual Samskaras",
            "Weekly/Monthly Pooja",
            "Paid Seva",
            "Abhisekha Sponsorship",
          ],
        },
        {
          subTab: "Services",
          supersubItems: ["Religious", "Human", "Youth&Education"],
        },

        { subTab: "Newsletter", supersubItems: ["List of Newletters"] },
        { subTab: "Awards" },
        {
          subTab: "Event Facilities",
          supersubItems: ["All Photos and Videos"],
        },
        { subTab: "Management Team", supersubItems: ["Team 1", "Team 2"] },
        { subTab: "Refund Policy" },
      ],
      isShow: true,
    },
    {
      page: "Services",
      icon: <ExpandMoreIcon style={{position:"relative", top:"3px"}}/>,
      subTabs: [
        { subTab: "Human Services" },
        { subTab: "Youth and Education" },
        { subTab: "Young Adult's" },
        { subTab: "Golden Ager's" },
        { subTab: "Cultural", supersubItems: ["Cultural 1", "Cultural 2"] },
      ],
      isShow: true,
    },
    {
      page: "Calendar",
      onclickFunction: handleClickCalender,
      isShow: true,
    },
    {
      page: "Donation",
      onclickFunction: () => {
        handleClickDonation();
        window.scrollTo(0, 0);
      },
      isShow: true,
    },
    {
      page: "Temple History",
      onclickFunction: handleTempleHistory,
      isShow: true,
    },
    {
      page: "Contact Us",
      icon: <ExpandMoreIcon style={{position:"relative", top:"3px"}}/>,
      subTabs: [
        {
          subTab: "Contact Info",
          supersubItems: ["Address", "Map and Contact No", "members List"],
        },
        {
          subTab: "Send Feedback",
          supersubItems: ["Form to fill and write feedback"],
        },
      ],
      isShow: true,
    },
  ];

  const handleTabMouseEnter = (tabName: string) => {
    setActiveTab(tabName);
  };

  const handleTabMouseLeave = () => {
    setActiveTab(null);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // const isMobile = false;

  // Function to toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const onClickRedirect = (path: string) => {
    window.open(path, "_blank");
  };

  const handleLogoutClick = () => {
    handleLogout();
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const rightContainer = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "10px",
          marginTop: "-40px",
        }}
      >
        <p style={{ color: "#fff", fontSize: "12px" }}>
          © {currentYear} Hindu Community and Cultural Center{" "}
        </p>
      </div>
    );
  };

  const mobileMenuItems = () => {
    return (
      <div>
        {/* <div style={{float: "right"}}>
          {!authService.isAuthenticated() ? (
            <Login handleClickDonation={handleClickDonation} />
          ) : (
            userDetailsInfo()
          )}
        </div> */}
        {/* <div>{SearchBox()}</div> */}
        <div style={{ height: "auto", marginBottom: "20px" }}>
          <List>
            {menuData.map((item, index) => (
              <React.Fragment key={index}>
                <ListItem
                  button
                  onClick={() => {
                    handleTabMouseEnter(item.page); // Ensure the sub-tabs are shown
                    item?.onclickFunction?.();
                    if (item.page && !item?.subTabs?.length) toggleMobileMenu();
                  }}
                >
                  <ListItemText sx={{ color: "#fff" }} primary={item.page} />
                  {item?.subTabs && <ArrowDropDownIcon style={{ color: '#fff' }} />}
                </ListItem>
                {activeTab === item.page && item?.subTabs && (
                  <List sx={{ marginLeft: 5 }}>
                    {item.subTabs.map((subTab, subIndex) => (
                      <ListItem
                        key={subIndex}
                        button
                        onClick={() => {
                          handleSubTabClick(subTab.subTab);
                          toggleMobileMenu();
                        }}
                        style={{ paddingLeft: 20 }}
                      >
                        <ListItemText
                          sx={{
                            color: "#fff",
                            marginBottom: "0px",
                            marginTop: "0px",
                          }}
                          primary={subTab.subTab}
                        />
                      </ListItem>
                    ))}
                  </List>
                )}
              </React.Fragment>
            ))}
          </List>
        </div>
        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CommonLogoutButton sx={{ color: "#882E14" }} onClick={handleLogoutClick}>Logout</CommonLogoutButton>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              gap: "20px",
              marginTop: "20px",
            }}
          >
            <div
              onClick={() =>
                onClickRedirect("https://www.facebook.com/Livermoretemple")
              }
            >
              <img
                style={{ height: "30px", width: "30px" }}
                src="/images/facebookIcon.svg"
                className={styles.facebookIcon}
              />
            </div>
            <div
              onClick={() =>
                onClickRedirect(
                  "https://twitter.com/i/flow/login?redirect_after_login=%2Flivermoretemple"
                )
              }
            >
              <img
                style={{ height: "30px", width: "30px" }}
                src="/images/twitterIcon.svg"
                className={styles.twitterIcon}
              />
            </div>
            <div
              onClick={() =>
                onClickRedirect("https://www.instagram.com/livermoretemple")
              }
            >
              <img
                style={{ height: "30px", width: "30px" }}
                src="/images/instagramIcon.svg"
                className={styles.instagramIcon}
              />
            </div>
            <div
              onClick={() =>
                onClickRedirect("https://www.youtube.com/c/LivermoreTempletv")
              }
            >
              <img
                style={{ height: "30px", width: "30px" }}
                src="/images/youtubeIcon.svg"
                className={styles.youtubeIcon}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "0px",
              gap: "10px",
            }}
          >
            <div
              onClick={() =>
                onClickRedirect(
                  "https://itunes.apple.com/us/app/livermore-temple/id1186574740?mt=8"
                )
              }
            >
              <img
                style={{ height: "100px", width: "100px" }}
                src="/images/App_store_logo.svg"
                className={styles.youtubeIcon}
              />
            </div>
            <div
              onClick={() =>
                onClickRedirect(
                  "https://play.google.com/store/apps/details?id=com.livermore.devotee"
                )
              }
            >
              <img
                style={{ height: "100px", width: "100px" }}
                src="/images/Googleplay.svg"
                className={styles.youtubeIcon}
              />
            </div>
          </div>
          {rightContainer()}
        </div>
      </div>
    );
  };

  const SearchBox = () => {
    return (
      <div className={styles.searchBox}>
        <TextField
          sx={{
            backgroundColor: "#FFF9E4",
            width: 130,
            borderRadius: "4px",
            border: "none",
          }}
          id="input-with-icon-textfield"
          placeholder="Search"
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#F05802" }} />
              </InputAdornment>
            ),
          }}
        />
      </div>
    );
  };

  const handleOpenUserMenu = () => {
    setMenuVisible(!menuVisible);
    setShowSubRoles(false);
  };

  const handleClickChangeRole = () => {
    setShowSubRoles(!showSubRoles);
  };

  const activateChangeRole = (subRole: roleListProps) => {
    if (!rolesForLink.includes(subRole.roleName)) {
      setSelectedRole(subRole.roleName);
      sessionStorage.setItem("selectedRole", subRole.roleName);
      sessionStorage.setItem("userRoleId", JSON.stringify(subRole.roleId));
      setShowSubRoles(!showSubRoles);
      window.open(
        `${process.env.REACT_APP_BASE_ASP_URL}/hints/manage/validate_token.asp?token=${getaccessToken()}&username=${getUserName()}&userRoleId=${subRole.roleId
        }`,
        "_blank"
      );
      navigation(RoutingURLs.dashboard)
    } else {
      setSelectedRole(subRole.roleName);
      sessionStorage.setItem("selectedRole", subRole.roleName);
      setShowSubRoles(!showSubRoles);
      sessionStorage.setItem("userRoleId", `${subRole.roleId}`);
      if (
        constants.showDashBoardForRoles.includes(subRole.roleName)
      ) {
        if (constants.LANDINGPAGE_AUTHORIZE.includes(subRole.roleName)) {
          navigation(
            `/managerDashboard/expense-voucher/${SubRoutingURLs.AUTHORIZE}`
          );
        } else if (
          constants.LANDINGPAGE_MYSCHEDULES.includes(subRole.roleName)
        ) {
          navigation(
            `/managerDashboard/schedules/${SubRoutingURLs.MY_SCHEDULE}`
          );
        } else {
          navigation(
            `/managerDashboard/devoteeservice/${SubRoutingURLs.DEVOTEE_POOJA_AND_HALL_REQUESTS}`
          );
        }
        navigation(0);
      } else {
        navigation(RoutingURLs.dashboard);
        navigation(0);
      }
    }
  }

  const handleChangeRole = async (subRole: roleListProps) => {
    try {
      await apiRequest({
        method: "POST",
        endpoint: apiPath.activateRole?.replace("{0}", JSON.stringify(subRole.roleId)),
        includeToken: true,
      }).then(() => {
        activateChangeRole(subRole)
      });
    } catch (error) {
      // Handle errors, such as displaying an error message
      toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(error)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
        duration: constants.TOAST_POPUP_DURATION,
      });
    }
  };

  const handleLogout = async () => {
    try {
      await apiRequest({
        method: "POST",
        endpoint: apiPath.logoutPath,
        // includeToken: true,
      }).then(() => {
        sessionStorage.clear();
        navigation("/");
        setMenuVisible(false);
        setShowSubRoles(false);
        setSelectedRole("");
      });
    } catch (error) {
      // Handle errors, such as displaying an error message
      toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(error)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
        duration: constants.TOAST_POPUP_DURATION,
      });
    }
  };

  const handleEditProfile = () => {
    navigation(`/user/${userName}`);
    setMenuVisible(false);
  };

  const handleChangePassword = () => {
    setOpen(true);
    setShowChangePassword(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleDonationReport = () => {
    // setAnchorElUser(null);
    navigation("/donationreport");
  };

  const userInfoDetails = [
    {
      settings: "Change Role",
      onclickFunction: handleClickChangeRole,
      showArrow: true,
    },
    {
      settings: "Edit Profile",
      onclickFunction: () => {
        handleEditProfile();
        window.scroll(0, 180);
      },
      showArrow: false,
    },
    {
      settings: "Change Password",
      onclickFunction: handleChangePassword,
      showArrow: false,
    },
    // {
    //    settings: 'Donation Report',
    //    onclickFunction: handleDonationReport,
    // },
    {
      settings: "Logout",
      onclickFunction: handleLogout,
      showArrow: false,
    },
  ];

  const handleSubTabClick = (subTab: string) => {
    window.scroll(0, 200);
    // Redirect to different URLs based on the subtab
    switch (subTab) {
      case "Overview":
        navigation("/overview");
        break;
      case "Pooja Items":
        navigation("/poojaitems");
        break;
      case "Services":
        navigation("/serviceinformation");
        break;
      case "Newsletter":
        navigation("/newsletter");
        break;
      case "Awards":
        navigation("/awards");
        break;
      case "Event Facilities":
        navigation("/eventFacilities");
        break;
      case "Management Team":
        navigation("/mteam");
        break;
      case "Refund Policy":
        navigation("/refundPolicy");
        break;

      case "Human Services":
        navigation("/humanservices");
        break;
      case "Youth and Education":
        navigation("/servicesyouthandeducation");
        break;
      case "Young Adult's":
        navigation("/youngadults");
        break;
      case "Golden Ager's":
        navigation("/goldenAgers");
        break;
      case "Cultural":
        navigation("/cultural");
        break;
      case "Contact Info":
        navigation("/contactinfo");
        break;
      case "Send Feedback":
        navigation("/feedback");
        break;

      default:
        break;
    }
  };

  const handleClick = (index: any) => {
    setSelectedItem(index);
    setShowSubRoles(false);
  };

  const userDetailsInfo = () => {
    return (
      <div className={styles.mainUserDetails} ref={userDetailsRef}>
        <div className={styles.typoGraphys}>
          <div className={styles.userNameAndROle}>
            <div className={styles.username}>{name}</div>
            <CustomTooltip title={role}>
              <div className={styles.selectedrolename}>{role}</div>
            </CustomTooltip>
          </div>
          <Tooltip title="User Profile">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar
                sx={{
                  height: "32px",
                  width: "32px",
                  backgroundColor: "#F2BE22",
                }}
                alt=""
                src="/static/images/avatar/2.jpg"
              />
              <ExpandMoreIcon sx={{ color: "white" }} />
            </IconButton>
          </Tooltip>
        </div>

        {menuVisible && (
          <div className={styles.cardDetails} style={{ fontSize: "16px" }}>
            <ul className={styles.headerlist} id="menu">
              {userInfoDetails.map((setting, index) => (
                <li
                  key={index}
                  className={`${styles.userSettingsDropdown} ${selectedItem === index ? styles.activeTabs : ""
                    }`}
                  onClick={() => {
                    handleClick(index);
                    setting.onclickFunction();
                  }}
                >
                  <div>
                    {setting.settings}
                    {setting.showArrow && (
                      <KeyboardArrowRightIcon
                        style={{
                          float: "right",
                        }}
                      />
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
        {showSubRoles && (
          <div className={styles.subroleList}>
            {subRoles.map((subRole: roleListProps, roleIndex) => (
              <div
                key={roleIndex}
                id={subRole.roleName}
                onClick={() => {
                  handleChangeRole(subRole);
                  window.scroll(0, 180);
                }}
                className={`${styles.subRoleKey} ${selectedRole === subRole.roleName ? styles.activeTabs : ""
                  }`}
              >
                {subRole.roleName}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const isHomePage = window.location.pathname === "/";
  const isMyDashboard = window.location.pathname === RoutingURLs.dashboard;
  const isContactUs =
    window.location.pathname === "/contactinfo" ||
    window.location.pathname === "/publicTransportation" ||
    window.location.pathname === "/boardofdirectors" ||
    window.location.pathname === "/feedback";
  const isInformation =
    window.location.pathname === "/poojaitems" ||
    window.location.pathname === "/awards" ||
    window.location.pathname === "/mteam" ||
    window.location.pathname === "/overview" ||
    window.location.pathname === "/serviceinformation" ||
    window.location.pathname === "/newsletter" ||
    window.location.pathname === "/refundPolicy" ||
    window.location.pathname === "/eventFacilities";
  const isServices =
    window.location.pathname === "/cultural" ||
    window.location.pathname === "/humanservices" ||
    window.location.pathname === "/servicesyouthandeducation" ||
    window.location.pathname === "/goldenAgers" ||
    window.location.pathname === "/youngadults";

  const isCalendar = window.location.pathname === "/Calendar";
  const isDonation = window.location.pathname === "/donations";
  const isActiveTab = (tabName: string): boolean => {
    if (
      (isHomePage && tabName === "Home") ||
      (isMyDashboard && tabName === "My Dashboard") ||
      (isServices && tabName === "Services") ||
      (isDonation && tabName === "Donation") ||
      (isInformation &&
        (tabName === "Information" ||
          window.location.pathname.includes("/Information/"))) ||
      (isContactUs && tabName === "Contact Us") ||
      (tabName === "Contact Us" &&
        window.location.pathname.includes("/ContactUs/")) ||
      activeTab === tabName ||
      (isCalendar && tabName === "Calendar")
    ) {
      return true;
    }
    return false;
  };
  const menuItems = () => {
    return (
      <>
        {menuData.map((item, index: number) => (
          <>
            {item.isShow ? (
              <div
                key={index}
                onMouseEnter={() => handleTabMouseEnter(item.page)}
                onMouseLeave={handleTabMouseLeave}
                className={
                  isActiveTab(item.page) ? styles.activeTab : styles.tab
                }
                onClick={item?.onclickFunction}
              >
                {item.page}
                <p>{item?.icon}</p>
                {activeTab === item.page && (
                  <div className={styles.subTabs}>
                    {item?.subTabs?.map((subTabItem, index) => (
                      <div
                        key={index}
                        className={styles.subTab}
                        onClick={() => handleSubTabClick(subTabItem.subTab)}
                        onMouseEnter={() =>
                          handleSubTabMouseEnter(subTabItem.subTab)
                        }
                        onMouseLeave={handleSubTabMouseLeave}
                      >
                        {subTabItem.subTab}
                        {activeSubTab === subTabItem.subTab &&
                          subTabItem.supersubItems && (
                            <div
                              style={{
                                border: "0px solid blue",
                                borderRadius: "4px",
                              }}
                              className={styles.subTabs1}
                              onClick={handleClick}
                            >
                              {subTabItem.supersubItems.map(
                                (superSubItem, subIndex) => (
                                  <div
                                    key={subIndex}
                                    className={styles.subTab1}
                                    onClick={() =>
                                      handleSubTabClick(superSubItem)
                                    }
                                  ></div>
                                )
                              )}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </>
        ))}
      </>
    );
  };

  const changepasswordDialogbox = () => {
    return (
      <div>
        <Dialog
          style={
            isMobile
              ? {
                padding: "30px",
                backgroundRepeat: "round",
                backgroundImage: `url(${loginBgBanner})`,
              }
              : {}
          }
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xl"
          PaperProps={{
            style: {
              height: "calc(100% - 64px)",
              width: "calc(100% - 64px)",
              margin: "32px",
              maxWidth: "1148px",
              maxHeight: "644px",
            },
          }}
        >
          <div className={styles.closeIcon} onClick={handleClose}>
            <CustomCloseIcon />
          </div>
          <DialogContent style={
            isMobile
              ? { padding: "30px", height: "550px" }
              : loginScreen.contentPadding
          }>
            <Grid container style={
              isMobile
                ? { height: "100%", alignItems: "center", display: "flex", flexDirection: "column", marginTop: "40px" }
                : loginScreen.userForm
            }>
              <Grid
                item
                xs={6}
                component="form"
                noValidate
                sx={
                  isMobile
                    ? { width: "100%", maxWidth: "100%" }
                    : loginScreen.formPadding
                }
              >
                {showChangePassword ? (
                  <ChangePassword
                    handleClickDonation={handleClickDonation}
                    setOpen={setOpen}
                  />
                ) : (
                  ""
                )}
              </Grid>
              {!isMobile &&
                <LoginRightBanner handleDonateClick={handleClickDonation} />}
            </Grid>
          </DialogContent>
        </Dialog>
      </div>
    );
  };

  const DonationPopupDialog = () => {
    return (
      <div className={styles.scrollbar}>
        <Dialog
          open={isOpen}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xl"
          PaperProps={{
            style: {
              overflowY: "unset",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
            },
          }}
        >
          {/* <div
            style={{
              backgroundColor: "#882E14",
              height: "76px",
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "16px",
            }}
          >
            <DialogTitle sx={{ fontWeight: 700, fontSize: 36, color: "white" }}>
              {"Donation"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleDonateClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 16,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div> */}
          <CommonDonationPopup isOpen={isOpen} setIsOpen={setIsOpen} />
        </Dialog>
      </div>
    );
  };

  return (
    <>
      <div className={styles.mainMenu} id="menuBar">
        {/* <div className={styles.searchBoxContainer}>{SearchBox()}</div> */}
        <div className={styles.navBar}>
          {isMobile ? (
            <IconButton
              color="inherit"
              aria-label="open mobile menu"
              edge="start"
              onClick={toggleMobileMenu}
            >
              <CustomMobileMenuIcon />
            </IconButton>
          ) : (
            <div className={styles.navBar}>{menuItems()}</div>
          )}
        </div>
        <Drawer
          PaperProps={{
            sx: { width: "70%", backgroundColor: "#882E14" },
          }}
          anchor="left"
          open={mobileMenuOpen}
          onClose={toggleMobileMenu}
          ModalProps={{
            keepMounted: true,
          }}
        >
          {mobileMenuItems()}
        </Drawer>
        {/* <div className={styles.navBar}>{menuItems()}</div> */}
        <Dialog open={open}>{changepasswordDialogbox()}</Dialog>
        <div className={styles.userInfo}>
          {!authService.isAuthenticated() ? (
            <Login handleClickDonation={handleClickDonation} />
          ) : (
            userDetailsInfo()
          )}
        </div>
      </div>
      {DonationPopupDialog()}
    </>
  );
};

export default MenuBar;
